<template>
  <section class="menu-company">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <div class="menu-company-header">
      <h2>Dados da empresa:</h2>
      <div class="menu-company-header__card">
        <p>
          Empresa: <span>{{ company.name }}</span>
        </p>
        <p>
          CNPJ: <span>{{ company.cnpj }}</span>
        </p>
        <p>
          E-mail: <span>{{ company.email }}</span>
        </p>
        <p>
          Whatsapp: <span>{{ company.number_whats_app }}</span>
        </p>
        <p>
          Responsável: <span>{{ company.answerable }}</span>
        </p>
        <p>
          Número de colaboradores:
          <span>{{ company.number_of_collaborators }}</span>
        </p>
      </div>
    </div>
    <div class="menu-company-body">
      <h2>Menus:</h2>
      <div class="menu-company-body__links">
        <router-link
          class="menu-company-body__item"
          :to="{
            name: 'EditCompany',
            params: {
              id: $route.params.id,
              slug: $route.params.slug,
            },
          }"
        >
          <p>Editar informações</p>
          <div class="icon">
            <svg
              width="8"
              height="16"
              viewBox="0 0 8 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_20_670)">
                <mask
                  id="mask0_20_670"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="1"
                  width="8"
                  height="15"
                >
                  <path
                    d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_20_670)">
                  <path
                    d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                    fill="black"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_20_670">
                  <path
                    d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </router-link>
        <router-link
          class="menu-company-body__item"
          :to="{
            name: 'ListPlansCompany',
            params: {
              id: $route.params.id,
              slug: $route.params.slug,
            },
          }"
        >
          <p>Planos</p>
          <div class="icon">
            <svg
              width="8"
              height="16"
              viewBox="0 0 8 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_20_670)">
                <mask
                  id="mask0_20_670"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="1"
                  width="8"
                  height="15"
                >
                  <path
                    d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_20_670)">
                  <path
                    d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                    fill="black"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_20_670">
                  <path
                    d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </router-link>
        <router-link
          class="menu-company-body__item"
          :to="{
            name: 'ListAdminsCompany',
            params: {
              id: $route.params.id,
              slug: $route.params.slug,
            },
          }"
        >
          <p>Administradores</p>
          <div class="icon">
            <svg
              width="8"
              height="16"
              viewBox="0 0 8 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_20_670)">
                <mask
                  id="mask0_20_670"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="1"
                  width="8"
                  height="15"
                >
                  <path
                    d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_20_670)">
                  <path
                    d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                    fill="black"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_20_670">
                  <path
                    d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </router-link>
        <router-link
          class="menu-company-body__item"
          :to="{
            name: 'ListCollaboratorsCompany',
            params: {
              id: $route.params.id,
              slug: $route.params.slug,
            },
          }"
        >
          <p>Colaboradores</p>
          <div class="icon">
            <svg
              width="8"
              height="16"
              viewBox="0 0 8 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_20_670)">
                <mask
                  id="mask0_20_670"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="1"
                  width="8"
                  height="15"
                >
                  <path
                    d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_20_670)">
                  <path
                    d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                    fill="black"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_20_670">
                  <path
                    d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </router-link>
        <router-link
          class="menu-company-body__item"
          :to="{
            name: 'ListProfessionalsCompany',
            params: {
              id: $route.params.id,
              slug: $route.params.slug,
            },
          }"
        >
          <p>Profissionais</p>
          <div class="icon">
            <svg
              width="8"
              height="16"
              viewBox="0 0 8 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_20_670)">
                <mask
                  id="mask0_20_670"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="1"
                  width="8"
                  height="15"
                >
                  <path
                    d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_20_670)">
                  <path
                    d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                    fill="black"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_20_670">
                  <path
                    d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/breadcrumb/Index";

export default {
  components: {
    Breadcrumb,
  },
  computed: {
    ...mapGetters("Company", ["companies", "companyPlans"]),
    hasParams() {
      return this.$route.params && Object.keys(this.$route.params).length > 0;
    },
  },
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
        {
          name: "Menu Empresa",
          routerName: "MenuCompany",
        },
      ],
      dataProps: { module: "Company" },
      company: {},
    };
  },
  async mounted() {
    if (this.hasParams) {
      await this.consultCompanies(this.$route.params);
      this.handleDataPropsAndBreadcrumb();
      this.setNumberOfCollaboratorsInStore();

      const payload = { id: this.$route.params.id };
      await this.consultCompanyPlans(payload);
      this.setHasPlanActive();
    }
  },
  methods: {
    ...mapActions("Company", [
      "consultCompanies",
      "consultCompanyPlans",
      "setDataDefault",
    ]),
    handleDataPropsAndBreadcrumb() {
      this.dataProps = {
        name: this.companies.name,
        id: this.$route.params.id,
        module: "Company",
        type: "Company",
      };
      this.company = this.companies;
      this.links[2].name = `Menu - ${this.$route.params.slug}`;
    },
    setNumberOfCollaboratorsInStore() {
      this.setDataDefault([
        "SET_COMPANY_NUMBER_OF_COLLABORATORS",
        this.company.number_of_collaborators,
      ]);
    },
    setHasPlanActive() {
      const hasPlanActive = this.companyPlans.find((item) => item.is_active);
      this.setDataDefault(["SET_HAS_PLAN_ACTIVE", hasPlanActive]);
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-company {
  &-header {
    h2 {
      font-size: 24px;
      font-family: "Font Semibold";
      color: var(--black);
      text-align: left;
      margin-bottom: 20px;
    }
    &__card {
      background: var(--white);
      border-radius: 20px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      padding: 30px 20px;
      display: grid;
      grid-template-columns: 2fr 2fr;
      text-align: left;
      @media (max-width: 767px) {
        grid-template-columns: auto;
      }
      p {
        font-size: 16px;
        font-family: "Font Regular";
        color: var(--black);

        span {
          font-family: "Font Bold";
        }
      }
    }
  }
  &-body {
    margin: 30px 0;
    h2 {
      font-size: 24px;
      font-family: "Font Semibold";
      color: var(--black);
      text-align: left;
      margin-bottom: 20px;
    }
    &__links {
      display: grid;
      gap: 20px;
      grid-template-columns: 2fr 2fr;
      @media (max-width: 767px) {
        grid-template-columns: auto;
      }
    }
    &__item {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: var(--white);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
      border-radius: 15px;
      padding: 0px 20px;
      transition: 500ms;
      @media (max-width: 767px) {
        width: 100%;
      }
      &:hover,
      &:focus {
        cursor: pointer;
        background: var(--yellow);
      }
      p {
        font-size: 20px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
        @media (max-width: 991px) {
          font-size: 14px;
        }
      }
      .icon {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--yellow);
        border-radius: 100%;
      }
    }
  }
}
</style>
